export default __webpack_public_path__ + "static/media/Bg-video-tuner-light.ab062b21.mp4";